/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {OfferBasicSchema} from 'components/Offers/schemas/offerBasicSchema'
import {useTranslation} from 'react-i18next'
import {z} from 'zod'
import {useMemo} from 'react'

export { OfferBasicSchema }

export const useOfferBasicSchema = () => {
    const { t } = useTranslation()

    return useMemo(
        () =>
            z.object({
                name: z.string().trim().optional().nullable(),
                date: z.string().trim().min(1, t('Date is required')),
                valid_until: z.string().trim().min(1, t('Valid until is required')),
                adults: z
                    .number({
                        message: t('Adults must be a number'),
                    })
                    .min(0, t('Adults must not be negative')),
                children: z
                    .number({
                        message: t('Children must be a number'),
                    })
                    .min(0, t('Children must not be negative')),
                company_id: z.number({ message: t('Company is required') }),
                contact_id: z
                    .union([z.number(), z.string()])
                    .nullable()
                    .optional(),
                probability: z
                    .number({
                        message: t('Probability must be a number'),
                    })
                    .min(0, t('Probability must be between 0 and 100'))
                    .max(100, t('Probability must be between 0 and 100'))
                    .nullable()
                    .optional(),
                duration_minutes: z
                    .number({
                        message: t('Duration must be a number'),
                    })
                    .min(0)
                    .nullable()
                    .optional(),
            }),
        [t]
    )
}

export type OfferBasicInputs = z.infer<ReturnType<typeof useOfferBasicSchema>>
